export default "__VITE_ASSET__DAmNBC6f__"